var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-gray-500 border border-solid w-full height-container rounded relative"},[_c('SidebarLeft'),_c('SidebarRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }